module.exports = __webpack_public_path__ + "static/assets/08368621f2a40a040dade6c626906797.png";